<template>
  <div
    class="tab-content-presentation"
    v-if="slideActive.activeTab == 2 && !isPresenting"
  >
    <RightColumnCommonSlidesConfig v-if="isUsingComponentCommonSlidesConfig" />

    <RightColumnImageConfig v-if="isUsingComponentImageConfig" />

    <div v-if="slideActive.type === 'youtube'">
      <YoutubeConfig />
    </div>

    <div v-if="slideActive.type === 'googleSlides'">
      <GoogleSlidesContentTab />
    </div>

    <div v-if="slideActive.type === 'spinnerWheel'">
      <SpinnerWheelContentTab />
    </div>

    <div v-if="slideActive.type === 'freestyle'">
      <FreestyleContentTab />
    </div>

    <div v-if="slideActive.type === 'qrcode'" class="mb-3">
      You can put this slide at the beginning of your presentation. You can
      also put this slide just before an interactive slide, so the audience
      are reminded again to join in with their devices.
    </div>

    <AhaInfoBox v-if="isReactionInfoBoxShowing">
      Reactions are now available on all slides.
    </AhaInfoBox>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

import RightColumnCommonSlidesConfig from '@/components-v2/presentation-editor/side-right/RightColumnCommonSlidesConfig.vue'
import RightColumnImageConfig from '@/components-v2/presentation-editor/side-right/RightColumnImageConfig.vue'
import YoutubeConfig from '@/components/presentations/types/YoutubeConfig.vue'
import GoogleSlidesContentTab from '@/components/presentations/types/GoogleSlidesContentTab.vue'
import SpinnerWheelContentTab from '@/components/presentations/types/SpinnerWheelContentTab.vue'
import FreestyleContentTab from '@/components/presentations/types/FreestyleContentTab.vue'

export default {
  components: {
    RightColumnCommonSlidesConfig,
    RightColumnImageConfig,
    YoutubeConfig,
    GoogleSlidesContentTab,
    SpinnerWheelContentTab,
    FreestyleContentTab,
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    ...mapGetters(['isPresenting']),
    isUsingComponentCommonSlidesConfig() {
      const slideTypes = [
        'multipleChoice',
        'imageChoice',
        'question',
        'openEnded',
        'wordCloud',
        'scale',
        'ideas',
        'pickAnswer',
        'leaderboard',
        'textSlide',
        'bulletPoints',
      ]
      return slideTypes.includes(this.slideActive.type)
    },
    isUsingComponentImageConfig() {
      const slideTypes = ['image', 'document']
      return slideTypes.includes(this.slideActive.type)
    },
    isReactionInfoBoxShowing() {
      return moment('2021/11/01').isAfter(moment())
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-content-presentation {
  padding: 0;
  position: relative;
  z-index: 7; // https://ahaslides.atlassian.net/browse/AHA-14039
}
</style>
